import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

FieldBuilder.setNamespace('Controlling');

export const LEVEL_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.Level.Name')
    .required()
    .minLength(1)
    .maxLength(100)
    .build(),
];

export const LEVEL_CONFIG = {
  entityName: 'Level',
  localizationKey: 'Controlling::Entity.Level',
  fields: LEVEL_FIELDS,
  permission: 'ControllingActivities.Levels',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Activities + MENU_NAME_SUFFIX,
};
